let SupportTicketStatus = /*#__PURE__*/function (SupportTicketStatus) {
  SupportTicketStatus["OPEN"] = "OPEN";
  SupportTicketStatus["AWAITING_INFORMATION"] = "AWAITING_INFORMATION";
  SupportTicketStatus["SOLVED"] = "SOLVED";
  SupportTicketStatus["NEW"] = "NEW";
  SupportTicketStatus["CLOSED"] = "CLOSED";
  return SupportTicketStatus;
}({});
let SupportTicketType = /*#__PURE__*/function (SupportTicketType) {
  SupportTicketType["PICKUP"] = "pickup";
  SupportTicketType["LOSS"] = "loss";
  SupportTicketType["DAMAGE"] = "damage";
  SupportTicketType["CANCEL"] = "cancel";
  SupportTicketType["LABEL"] = "label";
  SupportTicketType["DELIVERY"] = "delivery";
  SupportTicketType["BILLING"] = "billing";
  SupportTicketType["OTHER"] = "other";
  SupportTicketType["UNKNOWN"] = "unknown";
  return SupportTicketType;
}({});

export { SupportTicketStatus, SupportTicketType };
//# sourceMappingURL=SupportTicket.js.map
